import './sentry';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import * as Sentry from '@sentry/react';
import App from './App';
import AppStateProvider, { useAppState } from './state';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import ErrorDialog from './components/ErrorDialog/ErrorDialog';
import generateConnectionOptions from './utils/generateConnectionOptions/generateConnectionOptions';
import PrivateRoute from './components/PrivateRoute/PrivateRoute';
import theme from './theme';
import './types';
import { VideoProvider } from './components/VideoProvider';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import SentryBoundaryFallback from './pages/SentryBoundaryFallback';

const VideoApp = () => {
  const { error, setError, settings } = useAppState();
  const connectionOptions = generateConnectionOptions(settings);

  return (
    <VideoProvider options={connectionOptions} onError={setError}>
      <ErrorDialog dismissError={() => setError(null)} error={error} />
      <App />
    </VideoProvider>
  );
};

const container = document.getElementById('root');
if (!container) throw new Error('Root container missing in index.html');
const root = createRoot(container);

root.render(
  <ThemeProvider theme={theme}>
    <I18nextProvider i18n={i18n}>
      <CssBaseline />
      <Router>
        <Sentry.ErrorBoundary fallback={<SentryBoundaryFallback />}>
          <AppStateProvider>
            <Switch>
              <PrivateRoute exact path="/">
                <VideoApp />
              </PrivateRoute>
              <Route path="/ClientPage">
                <VideoApp />
              </Route>
              <Route path="/PractitionerPage">
                <VideoApp />
              </Route>
              <PrivateRoute path="/room/:URLRoomName">
                <VideoApp />
              </PrivateRoute>
              <Redirect to="/" />
            </Switch>
          </AppStateProvider>
        </Sentry.ErrorBoundary>
      </Router>
    </I18nextProvider>
  </ThemeProvider>
);
